module.exports = __webpack_public_path__ + "img/Group 2@2x(1).58d6282e.png";